import { State, appendOrMoveToIndexWith, appendValue, moveTo } from '@btime/state-monad'
import { propEq } from 'ramda'

export const groupedRepliesByCategory = replies =>
  replies.reduce((list, reply) => {
    const { id, name } = reply.question.category || {}
    const categoryDefaultObj = { id, name, replies: [] }
    return State.of(list)
      .map(appendOrMoveToIndexWith(propEq('id', id), categoryDefaultObj))
      .map(moveTo('replies'))
      .map(appendValue(reply))
      .fold()
  }, [])
